import { DatePicker, Form, Modal } from "antd";
import { useEffect, useState } from "react";
import { ContainerModalAssinatura, Title } from "../styles";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { layout } from "../../ViewInteresses/styles";
// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useAssinatura } from "../hooks/useAssinatura";
import { useNavigate } from "react-router-dom";
import { Assinatura } from "../../../interfaces/Assinatura";

export default function ModalAssinatura({
  isModalOpen,
  handleFechar,
  usuarioId,
  cotaUsuarioId,
}: any) {
  const [formCadastrarAssinatura] = Form.useForm();

  const [assinaturaData, setAssinaturaData] = useState<Partial<Assinatura>>({});

  const { cadastrar, success, error, isLoading, resetError, resetSuccess } =
    useAssinatura();

  // Exibe a Mensagem
  const { showError, showSuccess, contextHolder } = useMessage();

  // Função que armazena os dados alterados de Apartamento
  const assinaturaChange = (
    changedValues: Partial<Assinatura>,
    allValues: Partial<Assinatura>
  ) => {
    setAssinaturaData({
      usuarioId,
      cotasUsuariosId: cotaUsuarioId,
      ...allValues,
    });
  };

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        navigate(0);
      }, 2000);
    }

    if (error && !errorDisplayed) {
      // Mensagem de erro

      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        title="Cadastrar Assinatura"
        onOk={() => cadastrar(assinaturaData)}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            {contextHolder}
            <ContainerModalAssinatura>
              <Form
                {...layout}
                form={formCadastrarAssinatura}
                onValuesChange={(changedValues, allValues) =>
                  assinaturaChange(changedValues, allValues)
                }
                name="assinatura"
              >
                <Form.Item
                  name="dataAssinatura"
                  label="Data Assinatura "
                  className="formItems"
                >
                  <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item
                  name="dataVencimento"
                  label="Data Vencimento "
                  className="formItems"
                >
                  <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
              </Form>
            </ContainerModalAssinatura>
          </>
        }
      </Modal>
    </>
  );
}
